import { createUseStyles } from '../../theme/theming';

const useCoursePromotionPage = createUseStyles((theme) => {
  console.log(theme, 'themere');
  return {
    courseSuperContainer: {
      display: 'flex',
      justifyContent: 'center',
      background: theme?.colors?.background1,
      padding: ({ isMobile } = {}) =>
        isMobile
          ? `${theme.spacing.padding.small}px ${theme.spacing.padding.small}px`
          : `${theme.spacing.padding.regular}px ${theme.spacing.padding.medium}px`,
      '&, & *, & *:before, & *:after': {
        fontFamily: theme?.typography?.fontFamily,
        boxSizing: 'border-box'
      }
      // '& h2,& h3': {
      //   fontWeight: '500',
      //   '& b,& strong': {
      //     fontWeight: '700'
      //   }
      // }
    },
    sectionContainer: {
      margin: '0 auto',
      maxWidth: ({ containerWidth } = {}) => containerWidth
    },

    videoTestimonialContainer: {
      width: '100%',
      maxWidth: '1440px',
      fontFamily: theme?.typography?.fontFamily
    },

    videoTestimonialHeading: {
      fontSize: theme.typography.fontSize.subHead,
      lineHeight: '20px',
      letterSpacing: '3px',
      textTransform: 'uppercase',
      color: theme.palette.font.tertiary,
      wordBreak: 'break-word',
      fontWeight: '700'
    },

    videoTestimonialTitle: {
      fontSize: theme.typography.fontSize.h2,
      lineHeight: '71px',
      letterSpacing: '-3px',
      margin: '0',
      color: theme.palette.font.default,
      wordBreak: 'break-word'
    },

    videoCarouselContainer: {
      // marginTop: '16px'
    },

    coursePageCarousel: {
      display: 'flex',
      justifyContent: 'flex-start',
      gap: '32px'
    },

    '@media screen and (max-width: 767px)': {
      coursePageCarousel: {
        display: 'flex',
        flexDirection: 'column-reverse'
      }
    },

    iframeSuperContainer: {
      height: '100%',
      width: '100%',
      display: 'flex',
      alignItems: 'center'
    },

    iframeContainer: {
      width: '100%',
      position: 'relative',
      aspectRatio: '4/3',
      borderRadius: '8px',
      overflow: 'hidden'
    },

    offerText: {
      textAlign: 'center',
      color: theme.palette.font.primary,
      fontWeight: '700'
    },
    offerPrice: {
      fontSize: theme.typography.fontSize.h4,
      fontWeight: '700'
    },
    priceContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: 'fit-content',
      minHeight: '62px'
    },
    originalPrice: {
      textDecoration: 'line-through',
      color: 'rgba(51, 51, 51, 0.6)'
    },
    offerDiscount: {
      color: '#08BD80',
      fontWeight: '600'
    },
    bottomContainer: {
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '5%'
    },
    iframe: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      borderRadius: theme.shape.borderRadius.small
    },

    videoDetails: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '20px'
    },

    videoDetailsHeading: {
      fontSize: theme.typography.fontSize.h3,
      lineHeight: '48px',
      margin: '0',
      letterSpacing: '-1px',
      wordBreak: 'break-word',
      color: theme?.colors?.font1
    },
    courseViewContainer: {
      width: '445px',
      backgroundColor: '#f4f9ff',
      display: 'flex',
      padding: '24px',
      flexDirection: 'column',
      borderRadius: '10px'
      // paddingBottom: '10px',
      // paddingTop: '10px'
    },
    bannerContainer: {
      width: '100%',
      background: theme?.colors?.bannerColor,
      color: theme?.colors?.bannerCtaColor,
      fontWeight: '600',
      textAlign: 'center',
      padding: '10px 10px 23px 40px',
      wordWrap: 'break-word',
      position: 'relative',
      fontSize: '14px',
      transform: 'rotate(180deg)',
      clipPath:
        'polygon(0 0, 100% 0, 100% calc(100% - 10px), 0 calc(100% - 10px), 15px calc(50% - 10px/2))'
      // marginBottom: '16px'
    },

    bannerContainerText: {
      transform: 'rotate(180deg)'
    },

    emblemContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '10px'
    },

    courseEmblem: {
      background: '#F0F4F8',
      fontSize: theme.typography.fontSize.body,
      borderRadius: '4px',
      padding: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },

    courseDetailsTags: {
      // marginTop: '16px',
      display: 'flex',
      flexWrap: 'wrap'
    },
    courseDetailTag: {
      marginTop: '5px',
      display: 'flex',
      alignItems: 'center',
      marginRight: '20px',
      color: theme?.colors?.font1,
      '& div': {
        fontSize: theme.typography.fontSize.body,
        fontWeight: theme.typography.fontWeight.medium,
        marginLeft: '10px'
      }
    },
    courseDetailContent: {
      marginTop: '20px',
      fontSize: theme.typography.fontSize.body,
      lineHeight: '21px',
      wordBreak: 'break-word',
      color: theme?.colors?.font1,
      whiteSpace: 'pre-wrap',
      margin: '10px 0 20px'
    },

    courseDetailViewFullDetails: {
      cursor: 'pointer',
      fontSize: theme.typography.fontSize.body,
      textDecoration: 'underline',
      lineHeight: '21px',
      marginTop: '20px',
      color: theme.colors?.font1,
      wordBreak: 'break-word'
    },

    courseDetailTime: {
      color: '#EB5757',
      fontWeight: '600'
    },

    iconBackground: {
      display: 'flex',
      width: '36px',
      height: '36px',
      backgroundColor: theme?.colors?.icon,
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '6px'
    },
    payInstallmentContainer: {
      display: 'flex',
      gap: '20px',
      padding: '12px 16px',
      background: '#f4f9ff',
      borderRadius: '16px',
      marginTop: '32px',
      cursor: 'pointer'
    },
    payInstallmentHeader: {
      '& h4': {
        color: '#0A1629',
        fontSize: '20px',
        fontWeight: '600',
        margin: '0px'
      },
      '& p': {
        color: '#7D8592',
        fontSize: '16px',
        margin: '0px',
        fontWeight: '600',
        marginTop: '4px',
        lineHeight: '24px'
      }
    },
    arrowRightIcon: {
      marginLeft: 'auto'
    },
    '@media (max-width: 767px)': {
      bannerContainerText: {
        // fontSize: '16px'
      },
      courseViewContainer: {
        width: '100%',
        paddingBottom: '10px'
      },
      // courseSuperContainer: {
      //   padding: '20px 10px 60px 20px'
      // },
      videoCarousel: {
        flexDirection: 'column-reverse',
        gap: '20px'
      },

      videoCarouselContainer: {
        height: 'max-content'
        // paddingRight: '10px'
      },

      videoDetails: {
        width: '100%'
      },

      videoDetailsHeading: {
        // fontSize: '20px',
        fontWeight: '600',
        lineHeight: 'normal',
        letterSpacing: '0px',
        color: theme?.colors?.font1
      },
      videoTestimonialTitle: {
        // fontSize: '24px',
        lineHeight: '36px',
        letterSpacing: '-1px'
      },

      videoDetailsContent: {
        marginTop: '4px'
      }
    },
    '@media (max-width: 420px)': {
      bannerContainerText: {
        fontSize: '14px'
      }
    }
  };
});

export default useCoursePromotionPage;
